import {Component, OnInit} from '@angular/core';
import {Form, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../../helpers';
import {ActivatedRoute, Router} from '@angular/router';
import {ImageService} from '../../image.service';

class ImageSnippet {
  public pending = false;
  public status = 'init';

  constructor(public src: string, public file: File) {
  }
}

@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.scss']
})
export class PremiumComponent implements OnInit {

  public premium: any;
  public contractorId = null;

  public createNew = false;

  public form;
  public formSucces: string = null;
  public formError: string = null;
  public formProcessing = false;

  public openLast = false;
  public forceClosed = false;

  public loadingData = false;

  public smallQuill = {

    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
    ],

  };

  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private imageService: ImageService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
        title: this.fb.control('', Validators.required),
        content: this.fb.array([]),
      }
    );
  }

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      if (params.contractor) {
        this.contractorId = params.contractor;
        /*
        this.http.get(
          this.helper.getApiUrl('/timetable?timetable_mainContractor=' + params.contractor)).subscribe(
          (timetables) => {
            this.timetables = timetables;
          });
          */
      }
    });
    this.route.params.subscribe((params) => {
      if (params.premium) {
        if (params.premium === 'nov') {
          this.createNew = true;
          this.createForm();
        } else {
          this.loadingData = true;
          this.http.get(
            this.helper.getApiUrl('/premium/' + params.premium)).subscribe(
            (premium) => {
              this.premium = premium;
              this.createForm();

              this.form.controls.title.setValue(this.premium.title.raw);

              const content = this.form.get('content') as FormArray;
              if (this.premium.acf && this.premium.acf.premium_advancedContent) {
                this.premium.acf.premium_advancedContent.forEach((pr) => {

                  const group: any = {
                    layout: pr.acf_fc_layout,
                    title: pr.premium_advancedContent_title,
                  }

                  if (pr.acf_fc_layout === 'generalContent') {
                    group.generalText = pr.premium_advancedContent_general_freeText;
                    group.displayType = pr.premium_advancedContent_general_displayType;
                    group.thumb = pr.premium_advancedContent_general_thumb;
                    group.newThumb = null;
                  }

                  if (pr.acf_fc_layout === 'team') {
                    group.team = this.fb.array([]);
                    group.displayType = pr.premium_advancedContent_team_displayType;

                    pr.premium_advancedContent_team.forEach((tm) => {
                      group.team.push(this.fb.group({
                        name: tm.teamMember_name,
                        thumb: tm.teamMember_thumbnail,
                        newThumb: null,
                        description: tm.teamMember_description
                      }));
                    });
                  }

                  content.push(
                    this.fb.group(group)
                  );
                });
              }
              this.loadingData = false;
            });
        }
      }
    });
  }

  swap(arr: any[], index1: number, index2: number): any[] {
    if (index1 === index2) {
      arr.splice(index1, 1);
      return arr;
    }
    arr = [...arr];
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  moveBlock(index, way) {
    if (index < 0) {
      return;
    }

    if (index + way < 0) {
      return;
    }

    const content = this.form.get('content') as FormArray;
    const contentValue = content.value;

    if (index > content.length - 1) {
      return;
    }

    if (index + way > content.length - 1) {
      return;
    }

    this.forceClosed = true;

    const newContent = this.swap(contentValue, index + way, index);
    this.form.controls.content = this.fb.array([]);
    const content2 = this.form.get('content') as FormArray;
    newContent.forEach((pr) => {
      const group: any = {
        layout: pr.layout,
        title: pr.title,
      }

      if (pr.layout === 'generalContent') {
        group.generalText = pr.generalText;
        group.displayType = pr.displayType;
        group.thumb = pr.thumb;
        group.newThumb = pr.newThumb;
      }

      if (pr.layout === 'team') {
        group.team = this.fb.array([]);
        group.displayType = pr.displayType;

        pr.team.forEach((tm) => {
          group.team.push(this.fb.group({
            name: tm.name,
            thumb: tm.thumb,
            newThumb: tm.newThumb,
            description: tm.description
          }));
        });
      }
      content2.push(
        this.fb.group(group)
      );
    });
  }


  moveMember(block, index, way) {
    if (index < 0) {
      return;
    }

    if (index + way < 0) {
      return;
    }

    const content = this.form.get('content') as FormArray;
    const team = content.at(block).get('team') as FormArray;
    const contentValue = team.value;

    if (index > team.length - 1) {
      return;
    }

    if (index + way > team.length - 1) {
      return;
    }

    if (way === 0) {
      team.removeAt(index);
    } else {
      [contentValue[index], contentValue[index + way]] = [contentValue[index + way], contentValue[index]];
      team.setValue(contentValue);
    }
  }

  addTeamMember(block) {
    const content = this.form.get('content') as FormArray;
    const team = content.at(block).get('team') as FormArray;
    team.push(this.fb.group({
      name: '',
      thumb: null,
      newThumb: null,
      description: '',
    }));
  }

  addBlock(type) {
    const content = this.form.get('content') as FormArray;
    const group: any = {
      layout: type,
      title: '',
    }

    if (type === 'generalContent') {
      group.generalText = '';
      group.displayType = 'left';
      group.thumb = null;
      group.newThumb = null;
    }

    if (type === 'team') {
      group.team = this.fb.array([]);
      group.displayType = '3';
    }

    content.push(
      this.fb.group(group)
    );

    this.forceClosed = false;
    this.openLast = true;
  }

  update(form) {
    this.formProcessing = true;
    this.formSucces = null;
    this.formError = null;

    const data: any = {
      title: this.form.controls.title.value,
      fields: {
        premium_advancedContent: []
      },
    };

    const content = this.form.get('content') as FormArray;
    content.controls.forEach((control, index) => {

      if (control.value.layout === 'generalContent') {
        data.fields.premium_advancedContent.push({
          acf_fc_layout: control.value.layout,
          premium_advancedContent_title: control.value.title,
          premium_advancedContent_general_freeText: control.value.generalText,
          premium_advancedContent_general_displayType: control.value.displayType,
          premium_advancedContent_general_thumb: control.value.thumb ? control.value.thumb.id : false,
        });
      }

      if (control.value.layout === 'team') {
        const teamData = {
          acf_fc_layout: control.value.layout,
          premium_advancedContent_title: control.value.title,
          premium_advancedContent_team_displayType: control.value.displayType,
          premium_advancedContent_team: []
        };

        const team = control.get('team') as FormArray;
        team.controls.forEach((member) => {
          teamData.premium_advancedContent_team.push({
            teamMember_name: member.value.name,
            teamMember_description: member.value.description,
            teamMember_thumbnail: member.value.thumb ? member.value.thumb.id : false,
          });
        });

        data.fields.premium_advancedContent.push(teamData);
      }
    });

    if (this.createNew) {
      data.fields.premium_mainContractor = this.contractorId;
      data.status = 'publish';

      this.http.post(this.helper.getApiUrl('/premium'), data).subscribe(
        (unit: any) => {
          this.formProcessing = false;
          this.formSucces = 'Premium vsebina je bila uspešno kreirana.';
          this.createNew = false;
          this.router.navigate(['ustanova', this.contractorId, 'premium', unit.id], {queryParams: {}, replaceUrl: true});
        }, (error) => {
          this.formProcessing = false;
          this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
        });
    } else {
      this.http.put(this.helper.getApiUrl('/premium/' + this.premium.id), data).subscribe(
        (unit) => {
          this.formProcessing = false;
          this.formSucces = 'Podatki so bili uspešno shranjeni.';
        }, (error) => {
          this.formProcessing = false;
          this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
        });
    }
  }

  removeImage(teamItem) {
    teamItem.value.thumb = null;
    teamItem.value.newThumb = null;
  }

  uploadImage(imageInput: any, member: any, item: any) {
    if (!member) {
      member = item;
    }
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      member.value.newThumb = new ImageSnippet(event.target.result, file);

      member.value.newThumb.status = 'init';
      member.value.newThumb.pending = true;

      this.imageService.uploadImage(member.value.newThumb.file, member.value.name).subscribe(
        (res) => {
          member.value.newThumb.pending = false;
          member.value.newThumb.status = 'ok';
          member.value.thumb = res;
        },
        (err) => {
          member.value.newThumb.pending = false;
          member.value.newThumb.status = 'fail';
          member.value.newThumb.src = '';
        })
    });

    reader.readAsDataURL(file);
  }
}
